import { api } from 'app/config/apiConfig';
import { ChangeUserPasswordParams } from '../model/types';
import { USERS_PATH } from '../utils/constants';

export const changeUserPasswordApi = api.injectEndpoints({
  endpoints: (builder) => ({
    changeUserPassword: builder.mutation<void, { userId: string; params: ChangeUserPasswordParams }>({
      query: ({ userId, params }) => ({
        url: `${USERS_PATH}/${userId}/password`,
        method: 'PUT',
        body: params,
      }),
    }),
  }),
});

export const { useChangeUserPasswordMutation } = changeUserPasswordApi;
